import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Legal Notice | Justus Kraft" description="Legal notice and contact information for Justus Kraft LLC." keywords="legal notice, imprint, Justus Kraft, contact" ogType="website" data-id="element-335" data-mp="1m4gglrhe57me" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-336" data-mp="1w1bce2ma4twz">
        <div className="max-w-4xl mx-auto" data-id="element-337" data-mp="2a1m4f8zbsejq">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-338" data-mp="2a0b5pnkqlwzh">
            Legal Notice
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-339" data-mp="250q4t7m0bek4">
            <section className="mb-8" data-id="element-340" data-mp="2jqnopbcwli3i">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-341" data-mp="2jtjkat1a3uos">
                Address
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-342" data-mp="2ssde6bn866yn">
                Justus Kraft LLC
                <br data-id="element-343" data-mp="2oqs4ez5zm8so" />
                Represented by: Justus Kraft
                <br data-id="element-344" data-mp="2oscw8h0x3dmu" />
                7901 4th St. N, Ste. 300
                <br data-id="element-345" data-mp="1u71poudldplt" />
                St. Petersburg, FL 33702
                <br data-id="element-346" data-mp="1u8mkml3tjak7" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-347" data-mp="1y9oioym01gkl">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-348" data-mp="235wv448tavo2">
                Contact
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-349" data-mp="286ua67yiz9lc">
                Phone: +1 424-678-0686
                <br data-id="element-350" data-mp="2d4co6cregf07" />
                Email: jk@kraftjustus.com
              </p>
            </section>

            <section className="mb-8" data-id="element-351" data-mp="2h56bb3x0pps1">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-352" data-mp="2lxfxc8v0i5p1">
                EU Online Dispute Resolution
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-353" data-mp="2qwsjere278qk">
                The European Commission provides a platform for online dispute
                resolution (ODR):{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-354" data-mp="30ugoob9ajymz">
                  https://ec.europa.eu/consumers/odr/
                </a>
                . You can find our email address above in this legal notice.
              </p>
            </section>

            <section className="mb-8" data-id="element-355" data-mp="2g42yq14brsa8">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-356" data-mp="2tx2iwgf1yao4">
                Consumer Dispute Resolution
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-357" data-mp="2owxywgexqxt5">
                We are not willing or obliged to participate in dispute
                resolution proceedings before a consumer arbitration board.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}